function generateTrendData(days) {
  var dates = []
  var taobao = []
  var jd = []
  var pdd = []
  var douyin = []
  var now = new Date()
  for (var i = days - 1; i >= 0; i--) {
    var d = new Date(now)
    d.setDate(d.getDate() - i)
    dates.push((d.getMonth() + 1) + '/' + d.getDate())
    var weekday = d.getDay()
    var weekendFactor = (weekday === 0 || weekday === 6) ? 1.3 : 1
    taobao.push(Math.round((150000 + Math.sin(i * 0.3) * 30000 + Math.random() * 40000) * weekendFactor))
    jd.push(Math.round((100000 + Math.sin(i * 0.25) * 20000 + Math.random() * 30000) * weekendFactor))
    pdd.push(Math.round((60000 + Math.sin(i * 0.2) * 15000 + Math.random() * 20000) * weekendFactor))
    douyin.push(Math.round((30000 + Math.sin(i * 0.35) * 10000 + Math.random() * 15000) * weekendFactor))
  }
  return { dates: dates, taobao: taobao, jd: jd, pdd: pdd, douyin: douyin }
}

function generateRealtimeData() {
  var platforms = ['淘宝/天猫', '京东', '拼多多', '抖音']
  var skus = [
    'iPhone 16 Pro 256G 黑色', '华为Mate70 Pro 512G', '小米15 Ultra',
    '戴森V15 Detect吸尘器', 'SK-II神仙水230ml', 'Nike Air Max 270',
    'iPad Pro M4 11寸 256G', '索尼WH-1000XM5 头戴式', '兰蔻小黑瓶50ml',
    'MacBook Pro M4 14寸', '飞利浦电动牙刷HX6857', '雅诗兰黛小棕瓶眼霜15ml',
    '海尔冰箱BCD-470WFPJ', '美的空调KFR-35GW/N8XHA1', '格力空调KFR-26GW/NhGc1B',
    '优衣库U系列圆领T恤', '安踏C202 GT碳板跑鞋', '三只松鼠坚果大礼包',
    '罗技MX Master 3S鼠标', '小米20000mAh充电宝', 'AirPods Pro 2代',
    '华为MatePad Pro 13.2寸', '欧莱雅复颜玻尿酸套装', '阿迪达斯Ultraboost 24'
  ]
  var priceMap = {
    'iPhone 16 Pro 256G 黑色': 8999, '华为Mate70 Pro 512G': 6999, '小米15 Ultra': 5999,
    '戴森V15 Detect吸尘器': 4990, 'SK-II神仙水230ml': 1540, 'Nike Air Max 270': 899,
    'iPad Pro M4 11寸 256G': 8999, '索尼WH-1000XM5 头戴式': 2499, '兰蔻小黑瓶50ml': 980,
    'MacBook Pro M4 14寸': 14999, '飞利浦电动牙刷HX6857': 599, '雅诗兰黛小棕瓶眼霜15ml': 510,
    '海尔冰箱BCD-470WFPJ': 4599, '美的空调KFR-35GW/N8XHA1': 3299, '格力空调KFR-26GW/NhGc1B': 2899,
    '优衣库U系列圆领T恤': 99, '安踏C202 GT碳板跑鞋': 899, '三只松鼠坚果大礼包': 128,
    '罗技MX Master 3S鼠标': 699, '小米20000mAh充电宝': 149, 'AirPods Pro 2代': 1899,
    '华为MatePad Pro 13.2寸': 5199, '欧莱雅复颜玻尿酸套装': 399, '阿迪达斯Ultraboost 24': 1299
  }
  var data = []
  var now = new Date()
  for (var i = 0; i < 20; i++) {
    var t = new Date(now.getTime() - i * 15000)
    var h = String(t.getHours()).padStart(2, '0')
    var m = String(t.getMinutes()).padStart(2, '0')
    var s = String(t.getSeconds()).padStart(2, '0')
    var sku = skus[Math.floor(Math.random() * skus.length)]
    var basePrice = priceMap[sku] || 500
    var amount = Math.round(basePrice * (0.8 + Math.random() * 0.4))
    data.push({
      time: h + ':' + m + ':' + s,
      platform: platforms[Math.floor(Math.random() * platforms.length)],
      sku: sku,
      amount: amount
    })
  }
  return data
}

export var kpiData = {
  gmv: 12856320,
  gmvChange: 12.5,
  orderCount: 38562,
  orderTarget: 85,
  skuCount: 1286,
  skuActiveRate: 72.3,
  avgPrice: 333.5,
  avgPriceChange: -2.1,
  conversionRate: 3.85,
  conversionChange: 0.3
}

export var platformData = [
  { name: '淘宝/天猫', gmv: 5280000, orders: 15800, conversion: 4.2, avgPrice: 334, refundRate: 5.2, score: 4.8, color: '#00D4FF' },
  { name: '京东', gmv: 3850000, orders: 10200, conversion: 3.8, avgPrice: 377, refundRate: 3.1, score: 4.9, color: '#00FF88' },
  { name: '拼多多', gmv: 2260000, orders: 9800, conversion: 3.2, avgPrice: 231, refundRate: 6.8, score: 4.5, color: '#FF6B35' },
  { name: '抖音', gmv: 1466320, orders: 2762, conversion: 2.9, avgPrice: 531, refundRate: 4.5, score: 4.6, color: '#A855F7' }
]

export var saleTrend = generateTrendData(30)

export var geoData = [
  { name: '北京', value: 1256000 }, { name: '上海', value: 1185000 },
  { name: '广东', value: 2156000 }, { name: '浙江', value: 985000 },
  { name: '江苏', value: 876000 }, { name: '四川', value: 765000 },
  { name: '湖北', value: 654000 }, { name: '福建', value: 543000 },
  { name: '山东', value: 632000 }, { name: '河南', value: 521000 },
  { name: '湖南', value: 432000 }, { name: '河北', value: 398000 },
  { name: '辽宁', value: 356000 }, { name: '安徽', value: 312000 },
  { name: '陕西', value: 287000 }, { name: '重庆', value: 265000 },
  { name: '天津', value: 234000 }, { name: '云南', value: 198000 },
  { name: '广西', value: 176000 }, { name: '山西', value: 156000 },
  { name: '贵州', value: 134000 }, { name: '甘肃', value: 112000 },
  { name: '内蒙古', value: 98000 }, { name: '新疆', value: 86000 },
  { name: '吉林', value: 95000 }, { name: '黑龙江', value: 123000 },
  { name: '江西', value: 187000 }, { name: '海南', value: 76000 }
]

export var skuRanking = [
  { name: 'iPhone 16 Pro 256G', platform: '淘宝/天猫', sales: 1258000, quantity: 138, growth: 15.2 },
  { name: '华为Mate70 Pro 512G', platform: '京东', sales: 986000, quantity: 112, growth: 22.8 },
  { name: '戴森V15吸尘器', platform: '京东', sales: 856000, quantity: 285, growth: 8.5 },
  { name: 'SK-II神仙水230ml', platform: '淘宝/天猫', sales: 723000, quantity: 1520, growth: -3.2 },
  { name: '小米15 Ultra', platform: '拼多多', sales: 654000, quantity: 210, growth: 35.6 },
  { name: 'Nike Air Max 270', platform: '拼多多', sales: 532000, quantity: 1680, growth: 12.1 },
  { name: 'iPad Pro M4 11寸', platform: '京东', sales: 498000, quantity: 65, growth: 18.9 },
  { name: '索尼WH-1000XM5', platform: '淘宝/天猫', sales: 423000, quantity: 320, growth: -5.8 },
  { name: '兰蔻小黑瓶50ml', platform: '抖音', sales: 387000, quantity: 890, growth: 28.3 },
  { name: 'MacBook Pro M4 14寸', platform: '京东', sales: 356000, quantity: 32, growth: 9.7 },
  { name: 'AirPods Pro 2代', platform: '淘宝/天猫', sales: 298000, quantity: 156, growth: 11.2 },
  { name: '优衣库U系列T恤', platform: '淘宝/天猫', sales: 256000, quantity: 25800, growth: 18.5 }
]

export var categoryData = [
  { name: '女装', value: 3520000 },
  { name: '数码', value: 2860000 },
  { name: '美妆', value: 2150000 },
  { name: '家电', value: 1680000 },
  { name: '运动', value: 1230000 },
  { name: '食品', value: 890000 },
  { name: '家居', value: 526320 }
]

export var skuQuadrant = [
  { name: 'iPhone 16 Pro', sales: 1380, profitRate: 28, revenue: 1258000, platform: '淘宝/天猫' },
  { name: '华为Mate70 Pro', sales: 1120, profitRate: 32, revenue: 986000, platform: '京东' },
  { name: '戴森V15', sales: 2850, profitRate: 18, revenue: 856000, platform: '京东' },
  { name: 'SK-II神仙水', sales: 15200, profitRate: 45, revenue: 723000, platform: '淘宝/天猫' },
  { name: '小米15 Ultra', sales: 2100, profitRate: 12, revenue: 654000, platform: '拼多多' },
  { name: 'Nike Air Max', sales: 16800, profitRate: 35, revenue: 532000, platform: '拼多多' },
  { name: 'iPad Pro M4', sales: 650, profitRate: 22, revenue: 498000, platform: '京东' },
  { name: '索尼XM5', sales: 3200, profitRate: 15, revenue: 423000, platform: '淘宝/天猫' },
  { name: '兰蔻小黑瓶', sales: 8900, profitRate: 52, revenue: 387000, platform: '抖音' },
  { name: 'MacBook Pro', sales: 320, profitRate: 20, revenue: 356000, platform: '京东' },
  { name: '飞利浦牙刷', sales: 5600, profitRate: 38, revenue: 312000, platform: '淘宝/天猫' },
  { name: '雅诗兰黛眼霜', sales: 4200, profitRate: 48, revenue: 298000, platform: '抖音' },
  { name: '海尔冰箱', sales: 180, profitRate: 8, revenue: 265000, platform: '京东' },
  { name: '美的空调', sales: 260, profitRate: 10, revenue: 234000, platform: '拼多多' },
  { name: '格力空调', sales: 210, profitRate: 6, revenue: 198000, platform: '淘宝/天猫' },
  { name: '优衣库T恤', sales: 25000, profitRate: 42, revenue: 175000, platform: '淘宝/天猫' },
  { name: '安踏跑鞋', sales: 12000, profitRate: 30, revenue: 156000, platform: '拼多多' },
  { name: '三只松鼠零食', sales: 32000, profitRate: 25, revenue: 128000, platform: '抖音' },
  { name: '罗技鼠标', sales: 8500, profitRate: 20, revenue: 98000, platform: '京东' },
  { name: '充电宝20000mAh', sales: 18000, profitRate: 14, revenue: 86000, platform: '拼多多' }
]

export var realtimeData = generateRealtimeData()

export var leftKpiItems = [
  { label: '全平台销售额', value: 12856320, unit: '元', change: 12.5 },
  { label: '全平台订单量', value: 38562, unit: '单', change: 8.3 },
  { label: '在线SKU总数', value: 1286, unit: '个', change: 2.1 },
  { label: '平均客单价', value: 333.5, unit: '元', change: -2.1 },
  { label: '全平台转化率', value: 3.85, unit: '%', change: 0.3 },
  { label: '目标完成率', value: 85, unit: '%', change: 5.2 }
]
